








































import { snakeCase } from 'lodash'
import { Component, Prop } from 'vue-property-decorator'

import {  BotProperty, } from '../../../../../../../../../../BotProperties/components/Properties/types'
import { UseFields } from '../../../../../../../../../../Pi'
import { PropertyActionProxy } from '../../../../logic/Actions/PropertyAction/PropertyActionProxy'
import { ActionNodeProps } from '../../../../logic/types'
import PropertyActionSelectAction from './PropertyActionSelectAction.vue'
import PropertyActionSelectProperty from './PropertyActionSelectProperty.vue'
import PropertyActionSelectPropertyActionValueType from './PropertyActionSelectPropertyActionValueType.vue'
import PropertyActionValueSettings from './PropertyActionValue/PropertyActionValueSettings.vue'

@Component({
  components: {
    PropertyActionSelectAction,
    PropertyActionSelectPropertyActionValueType,
    PropertyActionSelectProperty,
    PropertyActionValueSettings,
  },
  data() {
    return {
      snakeCase,
    }
  }
})
export default class PropertyAction extends UseFields {
  @Prop() proxyAction!: PropertyActionProxy

  @Prop() getProperties!: ActionNodeProps['getProperties']

  @Prop() createNewProperty!: (path: string, name: string, parent?: number) => Promise<Array<BotProperty> | void>

  @Prop() mediaTargetId!: ActionNodeProps['target']
}
